import { __extends, __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import MaskedField from '../MaskedField/index.js';

var numberMask = createNumberMask({
  prefix: '$',
  allowDecimal: true
});

var CurrencyField =
/** @class */
function (_super) {
  __extends(CurrencyField, _super);

  function CurrencyField() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CurrencyField.prototype.render = function () {
    var _a = this.props,
        placeholder = _a.placeholder,
        maskedFieldProps = _a.maskedFieldProps,
        rest = __rest(_a, ["placeholder", "maskedFieldProps"]);

    return React.createElement(MaskedField, __assign({
      placeholder: placeholder,
      maskedFieldProps: __assign({
        mask: numberMask
      }, maskedFieldProps)
    }, rest));
  };

  CurrencyField.defaultProps = {
    placeholder: 'Enter amount',
    autoFocus: false
  };
  return CurrencyField;
}(React.Component);

export default CurrencyField;
//# sourceMappingURL=index.js.map
